import React from "react";
import "./About_Us.css";
import Common_Banner from "../common-components/common_banner/Common_Banner";
import About_Content from "./about_content/About_Content";
import Why_Choose from "./why_choose/Why_Choose";
import CertificatesSlider from "./CertificatesSlider/CertificatesSlider";
import AboutUs from "./AboutUs/AboutUs";
import Enquire_now from "../home/enquire_now/Enquire_now";
import Our_Customers from "./our_customers/Our_Customers";
import Our_team from "./our_team/Our_team";
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import Why_Choose1 from "./why_choose_section/Why_Choose";
import WhatsappChatbot from "../common-components/chatbot/Chatbot";


const About_Us = () => {
  return (
    <section className="About_Us">
      {/* <Common_Banner_2 imgSrc="/assets/images/about_us/banner/Banner-01.png" title_text="About Us"/> */}
          <WhatsappChatbot/>
            <Our_team />
      {/* <About_Content /> */}
      <Why_Choose1/>

      <Why_Choose />
      {/* <AboutUs /> */}
      {/* <CertificatesSlider /> */}
      {/* <Our_Customers /> */}
      
      <Enquire_now />
    </section>
  );
};

export default About_Us;
